import {
  $themeResource,
  callOnce,
  computed,
  useApiStore,
  useThemeConfigListState,
  useThemeState,
} from "#imports";

/**
 * Get the theme config for the current theme
 */
export async function useThemeConfig () {
  const themeState = useThemeState();
  const themesConfigListState = useThemeConfigListState();
  const apiStore = useApiStore();

  const themeResource = $themeResource();

  await callOnce( async () => {
    if ( themeState.value && !themesConfigListState.value[themeState.value] ) {
      // fetch theme config if needed
      const getTheme = () => themeResource.getThemeConfig( themeState.value! );
      themesConfigListState.value[themeState.value] = await apiStore.captureApiCall( themeState.value, getTheme );
    }
  } );

  return computed( () => themeState.value
    ? themesConfigListState.value[themeState.value]
    : null );
}
